import { renderForm } from 'smartdollar-lead-capture-form';

window.addEventListener('load', (event) => {
  const form = document.getElementById(
    'smartdollar-lead-capture-form-wrapper'
  );

  renderForm(form);
});
